export const usos = [
  {Id:'D', Nombre: "DESCANSO"},
  {Id:'I', Nombre: "INVERSION"},
  {Id:'L', Nombre: "LIQUIDEZ"},
  {Id:'P', Nombre: "PRINCIPAL"},
]
